export default "__VITE_ASSET__57dfdb2c__"